'use client';
import type { CSSProperties } from 'react';
import { StockPeekLine } from './StockPeekLine';
import { useStockSnapshot } from './StockSnapshotContext';

// Placeholder shown while the client-only map bundle (react-map-gl / mapbox-gl
// + the recharts market panel) streams in. The map is interactive-only, so a
// light "loading" state in place of SSR'd markup is an even trade and keeps the
// heavy libs out of the server worker bundle.
//
// The pane beside it is not a placeholder: it holds the server-rendered
// national snapshot, in the spot the Market tab will occupy (side column on
// desktop, closed bottom drawer on phones — geometry in tokens.css
// `.stock-loading-*`). So the page's HTML carries real inventory text, and
// desktop visitors read it while the map loads.
const wrap: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 auto',
  width: '100%',
  height: '100%',
  minHeight: '60vh',
  color: 'var(--fg-3, #64748b)',
  fontFamily: 'var(--font-mono, monospace)',
  fontSize: 13,
  letterSpacing: '0.04em',
};

export function StockMapLoading() {
  const snapshot = useStockSnapshot();
  const loading = (
    <div style={wrap} aria-busy="true" aria-live="polite">
      loading map…
    </div>
  );
  if (!snapshot) return loading;
  return (
    <div className="stock-loading-shell">
      {loading}
      <aside className="stock-loading-pane">
        <div className="mo-drawer-peek">
          <StockPeekLine />
        </div>
        <div className="stock-snapshot-card">{snapshot}</div>
      </aside>
    </div>
  );
}
